import countries from "../assets/Countries.json";
import tanzania from "../assets/Tanzania.json";
import burundi from "../assets/Burundi.json";
import congo from "../assets/DR_Congo.json";
import kenya from "../assets/Kenya.json";
import malawi from "../assets/Malawi.json";
import mozambique from "../assets/Mozambique.json";
import rwanda from "../assets/Rwanda.json";
import uganda from "../assets/Uganda.json";
import zambia from "../assets/Zambia.json";
import noFlyRegionData from "../assets/NoFlyRegion.json";

const linkedCountries = [
  { name: "Countries", data: countries, color: "#B0A87840" },
  { name: "Tanzania", data: tanzania, color: "#FFD70090" },
  { name: "Burundi", data: burundi, color: "#B0A8A8" },
  { name: "Congo", data: congo, color: "#A8A8C0" },
  { name: "Kenya", data: kenya, color: "#C0C088" },
  { name: "Malawi", data: malawi, color: "#88B0B0" },
  { name: "Mozambique", data: mozambique, color: "#B088B0" },
  { name: "Rwanda", data: rwanda, color: "#88B088" },
  { name: "Uganda", data: uganda, color: "#BBBBBB" },
  { name: "Zambia", data: zambia, color: "#B0A878" },
];

const noFlyRegion = [
  { name: "No Fly Region", data: noFlyRegionData, color: "#d05858" },
];

export { linkedCountries, noFlyRegion };
